import { render, staticRenderFns } from "./PriceComponent.vue?vue&type=template&id=4db17e62&scoped=true&"
import script from "./PriceComponent.vue?vue&type=script&lang=ts&"
export * from "./PriceComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PriceComponent.vue?vue&type=style&index=0&id=4db17e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db17e62",
  null
  
)

export default component.exports